

import { Link, useNavigate } from "react-router-dom";
import ReactEcharts from "echarts-for-react";
import React, { useState, useEffect, useRef, useCallback } from "react";
import whiteBgLogoImg from '../assets/brands/Knox_County_Schools_White.png';
import DarkBgLogoImg from '../assets/brands/Knox_County_Schools_White.png';
import DarkTheme from '../assets/brands/dark_mode_icon.svg';
import { TabView, TabPanel } from 'primereact/tabview';
import HRProfile from "./profile.component";
import { Sidebar } from 'primereact/sidebar';
import school_icon from '../assets/images/school_icon.png';
import avatar_head from '../assets/images/avatar_head.png';
import { Carousel } from 'primereact/carousel';
import { useDispatch, useSelector } from "react-redux";
import {
    fetchSchool_Performance_Fund_Type_Report, fetchSchool_Performance_School_Type_Report, fetchSchool_Performance_Metric_Report,
    fetchSchool_Performance_Map_Report, fetchSchool_Performance_Pie_Chart_Report
} from '../redux/slices/schoolperformance';
// import { GoogleMap, useJsApiLoader, Marker, InfoWindowF, MarkerF } from '@react-google-maps/api';
import { GoogleMap, useJsApiLoader, Marker, MarkerF, InfoWindowF, Circle, TrafficLayer, TransitLayer, BicyclingLayer, Polyline } from '@react-google-maps/api';
import locationIcon from "../assets/images/green_dot_pin.png";
import locationIcon1 from "../assets/images/red_dot_pin.png";
import locationIcon2 from "../assets/images/yellow_dot_pin.png";
import FilterComponent from "../components/filterComponent";
import LoaderContainer from "../components/LoaderContainer/LoaderContainer";
import AppliedFilters from "../components/filterComponent/AppliedFilters";
import { Tooltip } from "primereact/tooltip";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { OverlayPanel } from 'primereact/overlaypanel';
import ValueTooltip from "../components/Tooltip/valueTooltip";
import { format, getMetricDisplayValue } from "../utils";

export default function Schoolperformance(props) {

    const op = useRef(null);
    const circleRef = useRef(null);
    const [alertVisible, setAlertVisible] = useState(false);
    const [map, setMap] = useState(null);
    const [searchBy, setSearchBy] = useState("Location")
    const [mapBoundary, setMapBoundary] = useState("Radius")
    const [mapType, setMapType] = useState("roadmap")
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [radius, setRadius] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [performanceData, setPerformanceData] = useState(null);
    const mapRef = useRef();
    const [transitLayerVisible, setTransitLayerVisible] = useState(false);
    const [titles, setTitles] = useState({
        traffic: '',
        bicycling: '',
        transit: ''
    });


    // Default styles
    const defaultTransitStyle = [
        {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#757575" }] // Default color for transit
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#757575" }]
        }
    ];

    const highlightedTransitStyle = [
        {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#0000FF" }] // Blue color for transit lines near the location
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#0000FF" }] // Blue color for transit stations near the location
        }
    ];


    // Default styles for Bicycling
    const defaultBicyclingStyle = [
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#075107" }] // Default color for bicycling paths
        }
    ];

    // Highlighted styles for Bicycling
    const highlightedBicyclingStyle = [
        {
            featureType: "road",
            elementType: "geometry",
            //   stylers: [{ color: "#2c82be" }] // Red color for bicycling paths near the location
            stylers: [{ color: "#066d06" }] // Red color for bicycling paths near the location
        }
    ];

    // Example style for dark theme and light theme
    const darkMapStyle = [
        {
            featureType: "all",
            elementType: "geometry",
            stylers: [{ color: "#212121" }] // Default color for the map
        },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#212121' }] },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#2c2c2c" }] // Color for roads
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#000000" }] // Color for water
        },
        {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#757575" }] // Default color for transit (not near the specific location)
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#757575" }]
        },
        ...defaultBicyclingStyle
    ];
    const lightMapStyle = [
        {
            featureType: "all",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }] // Default color for the map
        },
    ];


    var pagename = window.location.pathname
    const containerStyle = {
        width: '100%',
        height: '100%'
    };
    const [formData, setFormData] = useState({
        city: '',
        zipcode: '',
        street: '',
        latitude: null,
        longitude: null
    });

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { city, zipcode, street, latitude, longitude } = formData
        const address = `${street}, ${city}, ${zipcode}`;
        handleSearch(address, latitude, longitude);
        if (op.current) {
            op.current.hide()
        }
        handleClear()

    };


    const center = {
        lat: 42.8700,
        lng: -85.6300
    };

    const schoolTypeAbbreviations = {
        'Elementary School': 'ES',
        'Middle School': 'MS',
        'High School': 'HS',
    }


    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            // Handle the Enter key event here
            // Perform the search or any other action
            handleSearch(searchQuery);
        }
    };

    const handleSearch = (address, lat = null, lng = null) => {
        const geocoder = new window.google.maps.Geocoder();
        let geocodeParams = {};

        if (lat && lng) {
            geocodeParams = { location: { lat: parseFloat(lat), lng: parseFloat(lng) } };
        } else if (address) {
            geocodeParams = { address };
        } else {
            console.error('Please provide either latitude and longitude or a valid address.');
            return;
        }

        geocoder.geocode(geocodeParams, (results, status) => {
            if (status === 'OK' && results[0]) {
                const location = results[0].geometry.location;

                // Set the selected place first
                setSelectedPlace({
                    lat: location.lat(),
                    lng: location.lng(),
                    name: results[0].formatted_address
                });

                setSearchQuery(results[0].formatted_address);

                // Ensure any previous circle is removed
                if (circleRef.current) {
                    circleRef.current.setMap(null);
                }

                // Convert radius from miles to meters
                const radiusInMeters = radius * 1609.34;

                if (mapBoundary != "All Schools") {
                    // Create and display the circle
                    const newCircle = new window.google.maps.Circle({
                        center: location,
                        radius: radiusInMeters,
                        map: map,  // Add circle to the map immediately
                        options: {
                            strokeColor: '#4469ef',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: '#c1ccf1',
                            fillOpacity: 0.35,
                        }
                    });

                    // Update the circle reference
                    circleRef.current = newCircle;

                    // Set performance data
                    setPerformanceData({
                        name: results[0].formatted_address,
                        performanceData: 'Example Performance Data' // Replace with actual performance data
                    });

                    // Optional: Zoom out to fit the circle within the map view
                    window.google.maps.event.addListenerOnce(map, 'idle', () => {
                        map.fitBounds(newCircle.getBounds());
                    });
                }


            } else {
                console.error('Geocode was not successful for the following reason: ' + status);
                // setAlertVisible(true)
            }
        });
    };


    const getAbbreviation = (fullName) => schoolTypeAbbreviations[fullName] || fullName;
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        // googleMapsApiKey: "AIzaSyBHkESRyB7oJAtl15zRm6cXnBBoe2rS9Ik",
        googleMapsApiKey: "AIzaSyAH5BzpQG2djFSzAYlBTIxonbpSKOJe-Ps",
        libraries: ['geometry'],
    })

    const [darkTheme, setDartTheme] = useState(true)

    const updateMapStyle = () => {
        const map = mapRef.current;
        if (!map) {
            console.error('Map reference is not set.');
            return;
        }

        const currentCenter = map.getCenter();
        const location = new window.google.maps.LatLng(center.lat, center.lng);
        const distance = window.google.maps.geometry.spherical.computeDistanceBetween(currentCenter, location);

        const transitStyle = titles?.transit === "Transit"
            ? (distance < 1000 ? highlightedTransitStyle : defaultTransitStyle)
            : defaultTransitStyle;

        const bicyclingStyle = titles?.bicycling === "Bicycling"
            ? highlightedBicyclingStyle
            : defaultBicyclingStyle;

        const styles = darkTheme
            ? darkMapStyle?.filter(item => item["featureType"] != "road").concat(bicyclingStyle)
            : '';

        map.setOptions({ styles });
    };


    const options = {
        // styles: darkTheme ? darkModeStyle : '',
        styles: darkTheme ? darkMapStyle : '',
        mapTypeControl: false,
        fullscreenControl: false,
        // zoomControl: false,
        streetViewControl: true,
        // mapTypeId: 'roadmap'

    };


    // const { isLoaded } = useJsApiLoader({
    //     id: 'google-map-script',
    //     googleMapsApiKey: "AIzaSyBHkESRyB7oJAtl15zRm6cXnBBoe2rS9Ik"  //need to define your google api key 
    // })
    useEffect(() => {
        const handleBeforeUnload = () => {
            window.sessionStorage.removeItem('SchoolType');
            window.sessionStorage.removeItem('Schoolname');
            window.sessionStorage.removeItem('Year');
            window.sessionStorage.removeItem('Gender');
            window.sessionStorage.removeItem('Ethincity');
            window.sessionStorage.removeItem('Grade');
            window.sessionStorage.removeItem('allfilter');
            window.sessionStorage.removeItem('selectedoptions');
            window.sessionStorage.removeItem('selectedoptions1');
            window.sessionStorage.removeItem('selectedoptions2');
            window.sessionStorage.removeItem('selectedoptions3');
            window.sessionStorage.removeItem('selectedmetric');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    const handleClick1 = () => {
        window.sessionStorage.removeItem('SchoolType');
        window.sessionStorage.removeItem('Schoolname');
        window.sessionStorage.removeItem('Year');
        window.sessionStorage.removeItem('Gender');
        window.sessionStorage.removeItem('Ethincity');
        window.sessionStorage.removeItem('Grade');
        window.sessionStorage.removeItem('allfilter');
        window.sessionStorage.removeItem('selectedoptions');
        window.sessionStorage.removeItem('selectedoptions1');
        window.sessionStorage.removeItem('selectedoptions2');
        window.sessionStorage.removeItem('selectedoptions3');
        window.sessionStorage.removeItem('selectedmetric');
    };
    // const [map, setMap] = useState(null)

    // const onLoad = React.useCallback(function callback(map) {
    //     const bounds = new window.google.maps.LatLngBounds(center);
    //     map.fitBounds(bounds);
    //     setMap(map)
    // }, [])

    const onLoad = useCallback((mapInstance) => {
        setMap(mapInstance);
        mapRef.current = mapInstance;
        updateMapStyle();
    }, []);


    useEffect(() => {
        updateMapStyle();
    }, [darkTheme, titles]);


    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const [visibleRight, setVisibleRight] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [pieChartData, setpieChartData] = useState([]);



    const handleClick = (key, title) => {
        setTitles(prevTitles => ({
            ...prevTitles,
            [key]: prevTitles[key] === title ? '' : title
        }));

        updateMapStyle()
    };

    const dispatch = useDispatch();
    const School_Performance_Fund_Type_Reportdata = useSelector(state => state.schoolperformance.School_Performance_Fund_Type_Report);
    const School_Performance_School_Type_Reportdata = useSelector(state => state.schoolperformance.School_Performance_School_Type_Report);
    const School_Performance_School_Type_ReportdataLoading = useSelector(state => state.schoolperformance.School_Performance_School_Type_Reportloading);

    const School_Performance_Metric_Reportata = useSelector(state => state.schoolperformance.School_Performance_Metric_Report);
    const School_Performance_Metric_ReportLoading = useSelector(state => state.schoolperformance.School_Performance_Metric_Reportloading);
    const School_Performance_Map_Reportdata = useSelector(state => state.schoolperformance.School_Performance_Map_Report);
    const School_Performance_Map_ReportLoading = useSelector(state => state.schoolperformance.School_Performance_Map_Reportloading);
    const School_Performance_Pie_Chart_Reportdata = useSelector(state => state.schoolperformance.School_Performance_Pie_Chart_Report);



    // let School_Performance_Metric_Reportatanew = School_Performance_Metric_Reportata;

    var School_Performance_Metric_Reportatanew = JSON.parse(JSON.stringify(School_Performance_Metric_Reportata))
        ?.filter(item => item["METRIC_NAME"] != "% of student above Reading Benchmark"
            && item["METRIC_NAME"] != "% of student above Writing Benchmark"
            && item["METRIC_NAME"] != "% of student above Speaking Benchmark"
            && item["METRIC_NAME"] != "% of student above Listening Benchmark"
            && item["METRIC_NAME"] != "Referral Rate"
            && item["METRIC_NAME"] != "Suspension Rate"
        );

    if (School_Performance_Metric_Reportatanew) {
        School_Performance_Metric_Reportatanew.map(itr => {
            if (itr["METRIC_NAME"] == "Students with >95% Attendance") {
                itr["color"] = "#2C4089"
                itr["order"] = 1
            } else if (itr["METRIC_NAME"] == "Chronic Absence Rate") {
                itr["color"] = "#2C82BE"
                itr["order"] = 2;
            }
            else if (itr["METRIC_NAME"] == "% of student above Math Benchmark") {
                itr["color"] = "#129C83"
                itr["order"] = 3
            } else if (itr["METRIC_NAME"] == "% of student above ELA Benchmark") {
                itr["color"] = "#129C83"
                itr["order"] = 4
            } else if (itr["METRIC_NAME"] == "% of student above Science Benchmark") {
                itr["color"] = "#129C83"
                itr["order"] = 5
            }
            else if (itr["METRIC_NAME"] == "# of Graduates") {
                itr["color"] = "#3A3365"
                itr["order"] = 6
            }
            // if (itr["METRIC_NAME"] == "# of Graduates") {
            //     itr["color"] = "#3A3365"
            //     itr["order"] = 10
            // } else if (itr["METRIC_NAME"] == "Students with >95% Attendance") {
            //     itr["color"] = "#2C4089"
            //     itr["order"] = 1
            // } else if (itr["METRIC_NAME"] == "Chronic Absence Rate") {
            //     itr["color"] = "#2C82BE"
            //     itr["order"] = 2;
            // } else if (itr["METRIC_NAME"] == "Referral Rate") {
            //     itr["color"] = "#892C69"
            //     itr["order"] = 4
            // } else if (itr["METRIC_NAME"] == "Suspension Rate") {
            //     itr["color"] = "#129C83"
            //     itr["order"] = 5
            // }
            // else if (itr["METRIC_NAME"] == "% of student above STAAR Reading benchmark") {
            //     itr["color"] = "#129C83"
            //     itr["order"] = 6
            // }
            // else if (itr["METRIC_NAME"] == "% of student above STAAR Math benchmark") {
            //     itr["color"] = "#129C83"
            //     itr["order"] = 3
            // }
            // else if (itr["METRIC_NAME"] == "% of student above NWEA ELA benchmark") {
            //     itr["color"] = "#129C83"
            //     itr["order"] = 8
            // }
            // else if (itr["METRIC_NAME"] == "% of student above NWEA Math benchmark") {
            //     itr["color"] = "#129C83"
            //     itr["order"] = 9
            // }

        })
    }

    if (School_Performance_Metric_Reportatanew) {
        School_Performance_Metric_Reportatanew = School_Performance_Metric_Reportatanew.slice().sort((a, b) => {
            return a.order - b.order
        })

    }

    // useEffect(() => {
    //     setSelectedmetricschool(School_Performance_School_Type_Reportdatanew?.[0]?.LABEL)
    // }, [School_Performance_School_Type_Reportdatanew?.[0]?.LABEL])

    useEffect(() => {
        dispatch(fetchSchool_Performance_Fund_Type_Report({
            "elasticQueryName": "School_Performance_Fund_Type_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchSchool_Performance_School_Type_Report({
            "elasticQueryName": "School_Performance_School_Type_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchSchool_Performance_Metric_Report({
            "elasticQueryName": "School_Performance_School_Type_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchSchool_Performance_Map_Report({
            "elasticQueryName": "School_Performance_Map_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "grad_filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }, {
                "columnName": "MEASURE_TYPE",
                "columnValue": ["All"],
                "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchSchool_Performance_Pie_Chart_Report({
            "elasticQueryName": "School_Performance_Pie_Chart_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "grad_filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }, {
                "columnName": "MEASURE_TYPE",
                "columnValue": ["All"],
                "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
    }, [])

    // useEffect(()=>{
    //     const ifameData=document.getElementById("iframeId")
    //     const lat=1.305385;
    //     const lon=30.923029;
    //     ifameData.src=`https://maps.google.com/maps?q=${lat},${lon}&hl=es;&output=embed`
    // })
    const navigate = useNavigate()

    const hangleLogOut = () => {
        localStorage.clear();
        window.location.href = "https://login.microsoftonline.com/common/oauth2/v2.0/logout";
    }

    const BarHeaderTemplate = (options) => {
        return (
            <div className="flex px-4 py-4 align-items-center" style={{ cursor: 'pointer' }} onClick={options.onClick}>
                <i className="pi pi-bars"></i>
            </div>
        )
    };
    const FilterHeaderTemplate = (options) => {
        return (
            <div className="flex px-4 py-4 align-items-center" style={{ cursor: 'pointer' }} onClick={options.onClick}>
                <i className="pi pi-sliders-v"></i>
            </div>
        )
    };
    const SettingHeaderTemplate = (options) => {
        return (
            <div className="flex px-4 py-4 align-items-center" style={{ cursor: 'pointer' }} onClick={options.onClick}>
                <i className="pi pi-cog"></i>
            </div>
        )
    };

    const mapBoundaryItems = [
        { label: 'Radius', value: 'Radius' },
        { label: 'All Schools', value: 'All Schools' },
    ];

    const locationItems = [
        { label: 'Location', value: 'Location' },
        // { label: 'Select an map', value: 'Select an map' },
    ]

    const [selectedmetricschool, setSelectedmetricschool] = useState("All");
    const [divRecord, setDivRecord] = useState("Chronic Absenteeism");
    const [yearShow, setYearShow] = useState({});
    const [divRecordschool, setDivRecordschool] = useState("Elementary Schools");

    function transformMetrics(data) {
        const negativeMetrics = ["Chronic Absenteeism", "Suspension Rate", "Referral Rate", "Out of School Suspensions", "In School Suspensions", "Recidivism rate"];

        return data.map(metric => {
            const TARGET_PERCENTAGE = Number(metric.TARGET_PERCENTAGE) || 0;
            const METRIC_VALUE = Number(metric?.CURRENT_PERCENTAGE) || 0;

            const difference = TARGET_PERCENTAGE - METRIC_VALUE;

            let metricIndicator = "neutral";

            if (negativeMetrics.includes(metric.METRIC_NAME)) {
                if (difference > 0) {
                    metricIndicator = "positive";
                } else if (difference < 0) {
                    metricIndicator = "negative";
                }
            } else {
                if (difference < 0) {
                    metricIndicator = "positive";
                } else if (difference > 0) {
                    metricIndicator = "negative";
                }
            }

            return {
                ...metric,
                DIFFERENCE: difference,
                METRIC_INDICATOR: metricIndicator
            };
        });
    }


    const transformedMetrics = transformMetrics(School_Performance_Map_Reportdata);



    // let School_Performance_Map_Reportdata11;
    const [School_Performance_Map_Reportdata11, setSchool_Performance_Map_Reportdata11] = useState([]);

    useEffect(() => {
        if (transformedMetrics.length > 0) {
            let filtered = [];
            if (selectedmetricschool != "All") {
                filtered = transformedMetrics.filter(
                    (item) =>
                        item.METRIC_NAME === divRecord &&
                        (item.SCHOOL_TYPE === selectedmetricschool)
                );
            } else {
                filtered = transformedMetrics.filter(
                    (item) =>
                        item.METRIC_NAME === divRecord
                );
            }
            setSchool_Performance_Map_Reportdata11(filtered);
            // const AllData = selectedmetricschool === "All" ? School_Performance_Map_Reportdata : filtered
            // setSchool_Performance_Map_Reportdata11(AllData);
        }
    }, [School_Performance_Map_Reportdata, divRecord, selectedmetricschool]);




    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;
    const items = School_Performance_Map_Reportdata11; // your array of items
    const totalPages = Math.ceil(items?.length / itemsPerPage);
    const handleNextClick = () => {
        setCurrentPage(currentPage === totalPages ? 1 : currentPage + 1);
    };
    const handlePrevClick = () => {
        setCurrentPage(currentPage === 1 ? totalPages : currentPage - 1);
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = items?.slice(startIndex, endIndex);

    useEffect(() => {

    }, []);

    const [isvisible, setVisible] = React.useState(false);
    const onClick = () => setVisible(!isvisible)
    const [selectedone, setSelectedone] = useState('1');
    const handleClickselected = (event, h) => {
        setSelectedone(h);
        setDivRecordschool(event.target.innerText);
        setSelectedMarker(null);
    }


    const [selectedmetric, setSelectemetric] = useState('1');
    const handleClickmetric = (event, h) => {
        setSelectemetric(h);
        setDivRecord(event.target.innerText);
        setSelectedMarker(null);
        setCurrentPage(1);
    }

    // useEffect(()=>{
    //     const ifameData=document.getElementById("iframeId")
    //     const lat=1.305385;
    //     const lon=30.923029;
    //     School_Performance_Map_Reportdata11.map(itr => {
    //         ifameData.src=`https://maps.google.com/maps?q=${itr.LATITUDE},${itr.LONGITUDE}&hl=es;&output=embed`
    //     })

    // })
    const [showDiv, setShowDiv] = useState(false);
    const handleTopTileFilterClick = (tile) => {
        setShowDiv(true);
    }
    const handleTopTileFilterClick1 = (tile) => {
        setShowDiv(false);
    }


    const handleMarkerClick = (marker) => {
        setSelectedMarker(marker);
    }

    const handleMarkerClick1 = (marker) => {
        setSelectedMarker(null);
    }

    const [selectedMarker, setSelectedMarker] = useState(null);

    const handleClear = () => {
        setFormData({
            city: '',
            zipcode: '',
            street: '',
            latitude: '',
            longitude: ''
        })
    }


    const transformedPie_ChartMetrics = transformMetrics(School_Performance_Pie_Chart_Reportdata);
    useEffect(() => {
        let School_Performance_Pie_Chart_Reportdata11;


        if (School_Performance_Pie_Chart_Reportdata) {
            School_Performance_Pie_Chart_Reportdata11 = transformedPie_ChartMetrics?.filter((item) => {
                // return item.METRIC_NAME == divRecord && item.SCHOOL_TYPE == selectedmetricschool &&
                //     item.SCHOOL_OFFICIAL_NAME == selectedMarker?.SCHOOL_OFFICIAL_NAME
                if (selectedMarker) {
                    return (item?.METRIC_NAME == divRecord) && (item?.SCHOOL_ID == selectedMarker?.SCHOOL_ID)
                }
                return item.METRIC_NAME == divRecord
            }
            );
            setpieChartData(School_Performance_Pie_Chart_Reportdata11)
        }
    }, [School_Performance_Pie_Chart_Reportdata, divRecord, selectedMarker])

    let uniqueEthnicity = [...new Set(pieChartData?.map(item => item["STUDENT_ETHNICITY"]))]?.sort()
    let uniqueEthnicityColors = ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de"]

    const StudentCenters = {
        tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '10%',
            top: "0%",
            containLabel: true
        },
        legend: {
            show: true,
            orient: 'horizontal',
            center: 'center',
            data: uniqueEthnicity,
            textStyle: {
                padding: [4, 20, 4, 20],
                borderRadius: 4
            },
            // right: '5%',
            // left: "60%",
            itemWidth: 8.5,
            itemHeight: 6,
            bottom: '10%',
            textStyle: {
                color: "#fff",
                fontSize: '9',
                fontStyle: 'normal'
            }
        },
        series: [
            {
                // name: 'Access From',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['50%', '40%'],

                avoidLabelOverlap: true,
                label: {
                    show: true,
                    position: 'left',
                    // formatter: '{d}%',
                    formatter: (params) => params.percent?.toFixed(1) + "%",
                    position: 'inside',
                    textStyle: {
                        fontSize: '8',
                        color: "#fff"
                    }
                },
                // emphasis: {
                //   label: {
                //     show: true,
                //     fontSize: 10,
                //     fontWeight: 'bold'
                //   }
                // },
                labelLine: {
                    show: false
                },
                data: pieChartData?.map((item) => {
                    let getIndex = uniqueEthnicity.indexOf(item?.STUDENT_ETHNICITY)
                    let color = uniqueEthnicityColors[getIndex]
                    return {
                        value: item?.VALUE, name: item?.STUDENT_ETHNICITY, itemStyle: { color }
                    }
                })
                // data : [
                //     {
                //         "value": 1,
                //         "name": "American Indian",
                //         "itemstyle": {
                //             "color": "red"
                //         }
                //     },
                //     {
                //         "value": 9,
                //         "name": "Asian",
                //         "itemstyle": {
                //             "color": "#377ab8"
                //         }
                //     },
                //     {
                //         "value": 2,
                //         "name": "Black",
                //         "itemstyle": {
                //             "color": "#377ab8"
                //         }
                //     },
                //     {
                //         "value": 49,
                //         "name": "Caucasian",
                //         "itemstyle": {
                //             "color": "#377ab8"
                //         }
                //     },
                //     {
                //         "value": 0,
                //         "name": "Native Hawaiian",
                //         "itemstyle": {
                //             "color": "#377ab8"
                //         }
                //     }
                // ]
                // data:
                //     pieChartData.map(x => {
                //         return {
                //             value: x?.VALUE,
                //             name: x?.STUDENT_ETHNICITY,
                //             itemstyle: {
                //                 color: '#377ab8',
                //             },
                //             // color : 'red'
                //         }
                //     })


                // {
                //     value: School_Performance_Pie_Chart_Reportdata11[0]?.VALUE,
                //     name: School_Performance_Pie_Chart_Reportdata11[0]?.STUDENT_ETHNICITY,
                //     itemStyle:
                //     {
                //         color: '#377ab8'
                //     }

                // },
                // {
                //     value: School_Performance_Pie_Chart_Reportdata11[1]?.VALUE,
                //     name: School_Performance_Pie_Chart_Reportdata11[1]?.STUDENT_ETHNICITY,
                //     itemStyle:
                //     {
                //         color: '#6f2e66'
                //     }
                // },
                // {
                //     value: School_Performance_Pie_Chart_Reportdata11[2]?.VALUE,
                //     name: School_Performance_Pie_Chart_Reportdata11[2]?.STUDENT_ETHNICITY,
                //     itemStyle:
                //     {
                //         color: '#2c4990'
                //     }

                // },
                // {
                //     value: School_Performance_Pie_Chart_Reportdata11[3]?.VALUE,
                //     name: School_Performance_Pie_Chart_Reportdata11[3]?.STUDENT_ETHNICITY,
                //     itemStyle:
                //     {
                //         color: '#41a5ac'
                //     }
                // },
                // {
                //     value: School_Performance_Pie_Chart_Reportdata11[4]?.VALUE,
                //     name: School_Performance_Pie_Chart_Reportdata11[4]?.STUDENT_ETHNICITY,
                //     itemStyle:
                //     {
                //         color: '#393469'
                //     }
                // },
                // {
                //     value: School_Performance_Pie_Chart_Reportdata11[5]?.VALUE,
                //     name: School_Performance_Pie_Chart_Reportdata11[5]?.STUDENT_ETHNICITY,
                //     itemStyle:
                //     {
                //         color: '#6f2e66'
                //     }
                // },
                // {
                //     value: School_Performance_Pie_Chart_Reportdata11[6]?.VALUE,
                //     name: School_Performance_Pie_Chart_Reportdata11[6]?.STUDENT_ETHNICITY,
                //     itemStyle:
                //     {
                //         color: '#359760'
                //     }
                // },

            }
        ]
    };

    const handleTopTileFilterClickmetric = (tile) => {

        setDivRecord(tile?.METRIC_NAME);
        setYearShow(tile)
        setSelectedMarker(null);
        setCurrentPage(1);
    }

    const handleTopTileFilterClick2 = (tile) => {
        setSelectedmetricschool(tile?.LABEL)
        setSelectedMarker(null);
        setCurrentPage(1);
    }

    const SchoolType = (props) => {
        const { label, value, percentage, clickerFunc, clicker } = props;

        const labelStyles = {
            "All": "bg-[#E99F4F]",
            "Elementary": "bg-[#498E71]",
            "High School": "bg-[#B55D5D]",
            "Middle School": "bg-[#3A3365]",
            "Alternative and Special Schools": "bg-[#129C83]",
            "Community Schools": "bg-[#129C83]",
            "Other": "bg-blue-500"
        };


        const bgColor = labelStyles[label] || `bg-[#000]`;

        return (
            <div onClick={() => clickerFunc(clicker)}>
                {label && (
                    <div
                        className={`${bgColor} w-full flex items-center justify-between p-2 text-white rounded ${label === selectedmetricschool ? "active" : " "
                            }`}
                    >
                        <div className="text-xs">{label}</div>
                        <div className="leading-none">
                            <ValueTooltip heading={label} value1={value} value2={percentage?.toFixed(1) + '%'}>
                                <span className="mr-2">{value}</span>
                            </ValueTooltip>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const TooltipAttributes = ({ categorydescription }) => {
        return {
            'data-pr-tooltip': `${categorydescription}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            // 'data-pr-className': 'custom-tooltip',
            style: { fontSize: '0rem', cursor: 'pointer' }
        }
    }

    const MetricTemplate = (MetricTemplate) => {
        return (
            <MetricTemplateMertic className='custom-target-icon' clicker={MetricTemplate} clickerFunc={handleTopTileFilterClickmetric} METRIC_ID={MetricTemplate?.METRIC_ID} METRIC_NAME={MetricTemplate?.METRIC_NAME} METRIC_MET_LABEL={MetricTemplate?.METRIC_MET_LABEL} />
        );
    };
    const MetricTemplateMertic = (props) => {
        return (
            <>
                <div id='cardtilesCustomer' onClick={
                    () => props.clickerFunc(props.clicker)
                } >
                    <Tooltip target=".custom-target-icon" />


                    <div className="flex justify-center custom-target-icon" {...TooltipAttributes({ categorydescription: props?.METRIC_MET_LABEL })} style={{ minHeight: 70 }} >
                        {
                            props?.METRIC_NAME == divRecord ?
                                <div className="mx-2 bg-white rounded-md box_sha1 text-[#1d1d31] border-4 border-t-[#FFC700] text-md p-2 w-full max-w-[173px] max-h-[70px] flex items-center text-center cursor-pointer justify-center" ><div style={{ width: "10rem" }}>{props?.METRIC_NAME}</div></div> :
                                <div className="mx-2 bg-[#0F0D0B] rounded-md box_sha1 text-white text-md p-2 w-full max-w-[173px] max-h-[70px] flex items-center text-center cursor-pointer justify-center" ><div style={{ width: "10rem" }}>{props?.METRIC_NAME}</div></div>
                        }


                    </div>
                </div>
            </>
        );
    };

    const darkModeStyle = [
        {
            "elementType": "geometry",
            "stylers": [{ "color": "#212121" }]
        },
        {
            "elementType": "labels.icon",
            "stylers": [{ "visibility": "off" }]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [{ "color": "#757575" }]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [{ "color": "#212121" }]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [{ "color": "#757575" }]
        },
        {
            "featureType": "administrative.country",
            "elementType": "labels.text.fill",
            "stylers": [{ "color": "#9e9e9e" }]
        },
        {
            "featureType": "administrative.land_parcel",
            "stylers": [{ "visibility": "off" }]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{ "color": "#212121" }]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{ "color": "#212121" }]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{ "color": "#181818" }]
        },
        {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{ "color": "#2c2c2c" }]
        },
        {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [{ "color": "#1f1f1f" }]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [{ "color": "#746855" }]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{ "color": "#000000" }]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [{ "color": "#3d3d3d" }]
        }
    ];

    const responsiveOptions = [

        {
            breakpoint: '865px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '1100px',
            numVisible: 3,
            numScroll: 2
        },
        {
            breakpoint: '1500px',
            numVisible: 4,
            numScroll: 1
        },
        {
            breakpoint: '1700px',
            numVisible: 4,
            numScroll: 1
        },
        {
            breakpoint: '1900px',
            numVisible: 5,
            numScroll: 1
        },
        {
            breakpoint: '3000px',
            numVisible: 5,
            numScroll: 1
        }

    ];

    // const options = {
    //     styles: darkModeStyle, // Add the dark mode styles here
    //     disableDefaultUI: true, // Optional: Disable default UI controls
    //     zoomControl: true, // Optional: Enable zoom control
    //     mapTypeControl: false,
    //     fullscreenControl: false,
    //     // zoomControl: false,
    //     streetViewControl: false
    // };

    const handleView = (type) => {
        setMapType(type)
    }

    const style = {
        backgroundImage: `url(${whiteBgLogoImg})`,
        backgroundRepeat: 'no-repeat'
    };


    const handleBoundaryChange = (value) => {
        setMapBoundary(value);

        if (value === "Radius") {
            // Show the circle if a place is selected
            if (selectedPlace) {
                // Ensure any previous circle is removed
                if (circleRef.current) {
                    circleRef.current.setMap(null);
                }

                // Convert radius from miles to meters
                const radiusInMeters = radius * 1609.34;

                // Create a new circle and update the ref
                circleRef.current = new window.google.maps.Circle({
                    center: { lat: selectedPlace.lat, lng: selectedPlace.lng },
                    radius: radiusInMeters,
                    map: map, // Immediately add circle to the map
                    options: {
                        strokeColor: '#4469ef',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#c1ccf1',
                        fillOpacity: 0.35,
                    }
                });

                // Adjust the map view to fit the circle within the bounds
                map.fitBounds(circleRef.current.getBounds());

            }
        } else if (value === "All Schools") {
            // Hide the circle if it exists
            if (circleRef.current) {
                circleRef.current.setMap(null);
            }

            // Adjust the map view to show all schools
            map.setZoom(11);
            map.panTo(center);
        }
    };

    const createPrimeMarkerIcon = (color) => {
        const svg = `
        <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 16 16'>
            <path fill='${color}' d='M8 0C4.686 0 2 2.686 2 6c0 4.418 6 10 6 10s6-5.582 6-10c0-3.314-2.686-6-6-6zm0 8.5A2.5 2.5 0 1 1 8 3.5a2.5 2.5 0 0 1 0 5z'/>
        </svg>
    `;

        return {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
            scaledSize: new window.google.maps.Size(30, 30),
            anchor: new window.google.maps.Point(15, 30),
        };
    };

    return (
        <div>

            <div className="relative z-10 w-full text-gray-700 py-4  top-0 headar-wrapper dark:bg-[#232528] dark:shadow-md">

                <div className="grid xl:grid-cols-5 grid-cols-4 gap-4">
                    {/* <div className="text-white ">
                        <div className="p-2 px-4">

                            <img src={darkTheme ? DarkBgLogoImg : whiteBgLogoImg} width={150} />
                        </div>
                    </div> */}
                    <div className="flex flex-row items-center justify-between p-2 px-4">
                        <Link to="/"
                        // className="text-lg font-semibold tracking-widest text-gray-900 uppercase rounded-lg dark-mode:text-white focus:outline-none focus:shadow-outline"
                        >
                            {/* <AppLogo /> */}
                            {/* <img src={whiteBgLogoImg} className="max-w-[80] min-h-[65px]" /> */}
                            <img src={whiteBgLogoImg} className="" width={60} style={{ height: 60 }} />

                            {/* <img src={whiteLogoImg} className="max-w-[200px] min-h-[65px]" /> */}
                        </Link>
                        <button className="rounded-lg md:hidden focus:outline-none focus:shadow-outline">
                            <svg fill="currentColor" viewBox="0 0 20 20" className="w-6 h-6">
                                <path x-show="!open" fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z" clipRule="evenodd"></path>
                                <path x-show="open" fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                    <div className=" col-span-2 ">
                        <label className={`text-[12px]  ${darkTheme ? 'text-white' : 'text-black font-bold'} align-left`}>Search by</label>
                        <div className="p-inputgroup w-full md:w-30rem custom-inputgroup">
                            <Dropdown
                                options={locationItems}
                                placeholder="Location"
                                value={searchBy}
                                onChange={(e) => {
                                    const { value } = e.target
                                    setSearchBy(value)
                                }}
                                className="p-inputgroup-addon p-rounded-left"
                            />
                            <span className="p-inputgroup-addon p-bg-primary">
                                <i className="pi pi-plus-circle cursor-pointer" style={{ fontSize: '1.5rem' }} onClick={(e) => op.current.toggle(e)}> </i>
                                <OverlayPanel ref={op}>
                                    <div className="card flex justify-content-center">
                                        <form className="p-fluid" >
                                            <div className="field">
                                                <label htmlFor="city">City</label>
                                                <InputText
                                                    id="city"
                                                    name="city"
                                                    value={formData.city}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter city"
                                                    autoComplete="city"
                                                />
                                            </div>
                                            <div className="field mt-2">
                                                <label htmlFor="zipcode">Zipcode</label>
                                                <InputText
                                                    id="zipcode"
                                                    name="zipcode"
                                                    value={formData.zipcode}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter zipcode"
                                                    autoComplete="zipcode"

                                                />
                                            </div>
                                            <div className="field mt-2">
                                                <label htmlFor="street">Street</label>
                                                <InputText
                                                    id="street"
                                                    name="street"
                                                    value={formData.street}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter street"

                                                />
                                            </div>
                                            <div className="field grid grid-cols-2 gap-2 mt-2">
                                                <div>
                                                    <label htmlFor="street">Latitude</label>
                                                    <InputText
                                                        id="latitude"
                                                        name="latitude"
                                                        value={formData.latitude}
                                                        onChange={handleInputChange}
                                                        placeholder="Latitude (##,00000...)"
                                                    />

                                                </div>

                                                <div>
                                                    <label htmlFor="street">Longitude</label>
                                                    <InputText
                                                        id="longitude"
                                                        name="longitude"
                                                        value={formData.longitude}
                                                        onChange={handleInputChange}
                                                        placeholder="Longitude (##,00000...)"
                                                    />

                                                </div>
                                            </div>

                                            <div className="grid grid-cols-5 gap-2 mt-5">
                                                <button class="button" onClick={(e) => {
                                                    e.preventDefault()
                                                    if (op.current) {
                                                        op.current.hide();
                                                    }
                                                }}>Cancel</button>
                                                <button class="button" onClick={(e) => {
                                                    e.preventDefault()
                                                    handleClear()

                                                }} >Clear</button>
                                                <button class="button" onClick={handleSubmit} >Submit</button>


                                            </div>
                                        </form>
                                    </div>
                                </OverlayPanel>
                            </span>
                            <InputText value={searchQuery} className="p-rounded-right custom-inputnumber" onChange={(e) => setSearchQuery(e.target.value)} onKeyDown={handleKeyDown} placeholder="Enter School or City or Zip code...." />

                        </div>
                    </div>
                    <div className="sm:mr-[2rem]">
                        <label className={`text-[12px]  ${darkTheme ? 'text-white' : 'text-black font-bold'} align-left`}>Map Boundary</label>
                        <div className="p-inputgroup w-full map-boundry-dropdown">
                            <Dropdown
                                options={mapBoundaryItems}
                                value={mapBoundary}
                                placeholder="Location"
                                onChange={(e) => handleBoundaryChange(e.target.value)}
                                // onChange={(e) => {
                                //     const { value } = e.target
                                //     setMapBoundary(value)

                                // }}
                                className="p-inputgroup-addon p-rounded-left"
                            />

                        </div>

                        {/* <div className="grid map-boundary">
                            <label className={`text-[12px]  ${darkTheme ? 'text-white' : 'text-black font-bold'} align-left`}>Map Boundary</label>
                            <Dropdown
                                options={mapBoundaryItems}
                                value={mapBoundary}
                                
                                onChange={(e) => {
                                    const { value } = e.target
                                    setMapBoundary(value)
                                   
                                }}
                                placeholder="Select a Location"
                                className="rounded-dropdown"
                            />
                        </div> */}
                    </div>
                    <div className="text-white">
                        <div className="grid map-boundary ml-2 in-miles lg:pt-2">
                            <label className={`text-[12px]  ${darkTheme ? 'text-white' : 'text-black font-bold'} align-left`}>Radius (in miles)</label>
                            {/* <InputNumber inputId="minmax-buttons" value={radius} mode="decimal" showButtons className="w-[50px] custom-inputnumber" /> */}
                            <InputNumber inputId="minmax-buttons" value={radius} onChange={(e) => {
                                setRadius(e.value)
                            }}
                                onKeyDown={handleKeyDown}
                                onValueChange={(e) => setRadius(e.value)} mode="decimal" showButtons className="w-[50px] custom-inputnumber" />


                        </div>
                    </div>
                    <div className="alert-dialog">
                        <Dialog header="Alert" visible={alertVisible} style={{ width: '50vw' }} onHide={() => { if (!alertVisible) return; setAlertVisible(false); }}>
                            <p className="m-0 mt-2">
                                Location not found! Please try another search.
                            </p>
                        </Dialog>

                    </div>
                    <div className={`absolute top-[42%] xl:top-[18%] right-3 text-lg text-white dark:text-black mt-0.5 cursor-pointer ${darkTheme ? 'bg-[#f0eaea8f] rounded-[50%]' : 'bg-black/60 rounded-[50%]'}`} onClick={(e) => { setDartTheme((prev) => !prev) }}>
                        {darkTheme ?
                            <img src={darkTheme ? DarkTheme : DarkTheme} width={24} /> :
                            <img src={darkTheme ? DarkTheme : DarkTheme} width={24} />}

                    </div>

                </div>


                <div x-data="{ open: false }" className="flex flex-col mx-auto md:items-center md:justify-end md:flex-row">

                    <nav className="bg-[#272321] py-1 hidden md:flex md:items-center md:justify-end md:flex-row">
                        <div className="flex-col items-center justify-end max-w-[350px]">
                            <h2 className="text-xl text-white text-end">School Performance</h2>
                            <p className="text-xs text-white text-end" style={{ position: "relative", left: "7px" }}>Comparative View of Key Areas Like Assessments and Behavior</p>
                        </div>

                        <div className="relative flex items-center gap-3 ml-5 profile-block" x-data="{ open: false }">
                            <div className="px-2"><button onClick={() => setVisibleRight(true)}><i className="pi pi-bars text-xl text-white"></i></button></div>
                            {/* <HRProfile /> */}
                        </div>
                    </nav>
                </div>
                <AppliedFilters pagename={"School Performance"} />
                <div>
                    <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>


                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="  " headerTemplate={BarHeaderTemplate} headerClassName="flex align-items-center">
                                <div className="bg-[#272321] p-5 h-[120px]">
                                    <h2 className="text-[18px] text-[#fff]">Navigation Menu</h2>
                                    <p className="text-[14px] text-[#fff]">Search through the list of Navigation menus</p>
                                </div>
                                <div className="px-3 py-3 menu">
                                    <ul onClick={handleClick1}>
                                        {/* <li className={pagename == "/"?"active":''}><Link  to='/'>District at a Glance</Link></li>
                                <li className={pagename == "/StrengthWeakness"?"active":''}><Link to='/StrengthWeakness'>Strength & Weakness</Link></li>
                                <li className={pagename == "/StudentPerformance"?"active":''}><Link to='/StudentPerformance'>Student Performance & Progress</Link></li>
                                <li className={pagename == "/enrollment"?"active":''}><Link to='/enrollment'>Enrollment</Link></li>
                                <li className={pagename == "/studentbehaviour"?"active":''}><Link to='/studentbehaviour'>Student Behaviour</Link></li>
                                <li className={pagename == "/schoolperformance"?"active":''}><Link to='/schoolperformance'>School Performance</Link></li> */}
                                        <Link to='/'><li className={pagename == "/" ? "active" : ''}><Link to='/'>District at a Glance</Link></li></Link>
                                        <Link to='/StrengthWeakness'><li className={pagename == "/StrengthWeakness" ? "active" : ''}><Link to='/StrengthWeakness'>Strength & Weakness</Link></li></Link>
                                        {/* <Link to='/StudentPerformance'><li className={pagename == "/StudentPerformance" ? "active" : ''}><Link to='/StudentPerformance'>Student Performance & Progress</Link></li></Link> */}
                                        {/* <li><Link to='/collegecareerreadiness'>College and Career Readiness</Link></li> */}
                                        {/* <li><Link to='/humanResources'>Human Resources</Link></li> */}
                                        <Link to='/enrollment'><li className={pagename == "/enrollment" ? "active" : ''}><Link to='/enrollment'>Enrollment</Link></li></Link>
                                        <Link to='/attendance'><li className={pagename == "/attendance" ? "active" : ''}><Link to='/attendance'>Student Attendance</Link></li></Link>
                                        {/* <li><Link to='/districtgoals'>District Goal & Strategy</Link></li> */}
                                        <Link to='/studentbehavior'><li className={pagename == "/studentbehavior" ? "active" : ''}><Link to='/studentbehavior'>Student Behavior</Link></li></Link>
                                        <Link to='/schoolperformance'><li className={pagename == "/schoolperformance" ? "active" : ''}><Link to='/schoolperformance'>School Performance</Link></li></Link>
                                        <Link to='/staffdetails'><li className={pagename == "/staffdetails" ? "active" : ''}><Link to='/staffdetails'>Staff Details</Link></li></Link>
                                        {/* <li className={pagename == "/statebenchmarking" ? "active" : ''}><Link to='/statebenchmarking'>State Benchmarking</Link></li> */}
                                        {/* <Link to='/annualplandashboard'><li className={pagename == "/annualplandashboard" ? "active" : ''}><Link to='/annualplandashboard'>Annual Plan Dashboard</Link></li></Link> */}
                                        {/* <li><Link to='/GraduationRateAnalysis'>Graduation Rate Analysis</Link></li> */}

                                    </ul>

                                </div>

                            </TabPanel>
                            <TabPanel header="" headerTemplate={FilterHeaderTemplate} headerClassName="flex align-items-center">
                                <div className="bg-[#272321] p-5 h-[auto]">
                                    <h2 className="text-[18px] text-[#fff]">Filters</h2>
                                    <p className="text-[14px] text-[#fff]">Apply filters for Advanced Search</p>
                                    <FilterComponent />
                                </div>
                            </TabPanel>
                            <TabPanel header="" headerTemplate={SettingHeaderTemplate} headerClassName="flex align-items-center">
                                <div className="bg-[#272321] p-5 h-[120px]">
                                    <div className="text-[18px] text-[#fff] mb-3" style={{ cursor: "pointer" }} onClick={hangleLogOut}>LogOut</div>
                                    <h2 className="text-[18px] text-[#fff]">Resources</h2>
                                    {/* <p className="text-[14px] text-[#fff]">SApply filters for Advanced Search</p> */}
                                </div>
                            </TabPanel>
                        </TabView>



                    </Sidebar>
                </div>
            </div>


            <div className="fixed left-0 top-0 bottom-0 right-0">
                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d122283.79110569143!2d74.16882735484785!3d16.708456761646506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1000cdec07a29%3A0xece8ea642952e42f!2sKolhapur%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1676303987916!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                {/* <iframe id="iframeId" height="100%" width="100%"></iframe> */}
                {isLoaded && School_Performance_Map_Reportdata.length > 0 ?
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={12.5}
                        options={options}
                        onLoad={onLoad}
                        mapTypeId={mapType}
                    >
                        {School_Performance_Map_Reportdata11?.map((location, index) => {
                            let metricValue = Number(location?.METRIC_VALUE?.replace("%", ""));
                            const positiveIcon = createPrimeMarkerIcon("#22c55e"); // Tailwind green-500
                            const negativeIcon = createPrimeMarkerIcon("#ef4444"); // Tailwind red-500
                            const neutralIcon = createPrimeMarkerIcon("#6b7280");  // gray (optional)
                            let Icon =
                                location?.METRIC_INDICATOR === "positive"
                                    ? positiveIcon
                                    : location?.METRIC_INDICATOR === "negative"
                                        ? negativeIcon
                                        : neutralIcon;

                            return (
                                <MarkerF
                                    key={index}
                                    position={{ lat: Number(location.LATITUDE), lng: Number(location.LONGITUDE) }}
                                    icon={Icon}
                                    onClick={() => handleMarkerClick(location)}
                                />
                            );
                        })}

                        {titles.traffic === "Traffic" ? <TrafficLayer /> : null}
                        {titles.transit === "Transit" ? <TransitLayer /> : null}
                        {titles.bicycling === "Bicycling" ? <BicyclingLayer /> : null}

                        {selectedMarker && (
                            <InfoWindowF
                                position={{
                                    lat: Number(selectedMarker.LATITUDE),
                                    lng: Number(selectedMarker.LONGITUDE),
                                }}
                                onCloseClick={() => handleMarkerClick1(null)}
                                options={{
                                    pixelOffset: new window.google.maps.Size(0, -30),
                                }}
                            >
                                <div style={{ maxWidth: "250px" }}>
                                    <div className="text-md font-semibold">{selectedMarker?.SCHOOL_OFFICIAL_NAME}</div>
                                    <div className="mt-1">
                                        <div className="text-[#3c474a] text-sm">
                                            <span className="font-semibold">School Type:</span> {selectedMarker?.SCHOOL_TYPE}
                                        </div>
                                        <div className="text-[#3c474a] text-sm">
                                            <span className="font-semibold">Grade:</span> {selectedMarker?.SCHOOL_GRADE_CONFIGURATION}
                                        </div>
                                        <div className="text-[#3c474a] text-sm">
                                            <span className="font-semibold">Address:</span> {selectedMarker?.ADDRESS_1}
                                        </div>
                                    </div>
                                </div>
                            </InfoWindowF>
                        )}
                    </GoogleMap>
                    : <></>
                }
            </div>

            <div className="px-4 mt-4">
                <div className="flex items-start justify-between">
                    <div className="bg-[#0F0D0B] w-full max-w-[30%] xl:max-w-[20%] p-1 box-sha relative z-10">
                        <div className="flex items-center justify-between">
                            <div className="text-md text-white">School Details</div>
                            <div className="flex gap-2">
                                <div className="text-md text-white"><i className="pi pi-map-marker"></i></div>
                                {/* <div>
                                    <label class="switch"><input type="checkbox" /> <span class="slider round"></span> </label>
                                </div> */}
                            </div>
                        </div>
                        <LoaderContainer loading={School_Performance_School_Type_ReportdataLoading} width={"100%"} height={"200px"}>
                            <div className="flex items-center space-x-3 mt-5">
                                <div className="text-center">
                                    <div className="w-[64px]">
                                        <img src={school_icon} alt="" />
                                    </div>
                                    <div className="mt-3">
                                        <div className="text-white font-semibold text-2xl leading-none">{School_Performance_School_Type_Reportdata[1]?.SUM_TOTAL}</div>
                                        <div className="text-white text-md">school</div>
                                    </div>
                                </div>
                                <div className="w-full space-y-1 school_tabs">
                                    {
                                        School_Performance_School_Type_Reportdata?.map(itr => {
                                            return (
                                                <SchoolType clicker={itr} clickerFunc={handleTopTileFilterClick2} value={itr?.VALUE} label={itr?.LABEL} percentage={itr?.PERCENTAGE} />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </LoaderContainer>
                    </div>

                    {selectedMarker && selectedMarker ?
                        <div className="bg-[#1b1c31]  text-white border-2 border-t-[#FFC700] border-b-[#FFC700] border-l-[#FFC700] border-r-[#FFC700] w-full max-w-[20%] school_table relative z-10">
                            <p className="head">{divRecord == 'Economically Disadvantaged' ? 'Free and Reduced Lunch' : divRecord}</p>
                            <div className="flex justify-between gap-4 px-4 py-2">
                                <div className="text-sm fontsemibold">School Information</div>
                                <div onClick={handleMarkerClick1}><Link><i className="pi pi-times f-s-9"></i></Link></div>
                            </div>
                            {/* <div className="px-5"><img src={school_campus} alt="" /></div> */}
                            <div className="text-[18px] px-5 py-1">{selectedMarker?.SCHOOL_OFFICIAL_NAME}</div>
                            <div className="text-[12px] text-white px-5"><i className="f-s-9 pi pi-flag-fill mr-1"></i>{selectedMarker?.ADDRESS_1}</div>
                            <div className="text-[10px] text-white px-5"><i className="f-s-9 pi pi-phone mr-1"></i></div>
                            <div className="flex items-center mt-2 gap-3 border-b border-white/[5] pb-2 px-5">
                                <div className="rounded overflow-hidden">
                                    <img src={avatar_head} className="max-w-[38px]" alt="" />
                                </div>
                                <div>
                                    <div className="text-xs">Principal</div>
                                    <div className="text-xs">{selectedMarker?.SCHOOL_PRINCIPAL}</div>
                                </div>
                            </div>
                            <div className="StudentCenters">
                                <div className="text-xs text-white text-center pt-2">{divRecord == 'Economically Disadvantaged' ? 'Free and Reduced Lunch' : divRecord}</div>
                                <div className="flex justify-between mt-2">
                                    <div className="flex items-center space-x-2 w-full">



                                        <div className="rounded overflow-hidden" style={{ position: "relative", left: "6px" }}>
                                            <img src={selectedMarker?.METRIC_INDICATOR === "positive" ? locationIcon : selectedMarker?.METRIC_INDICATOR === "negative" ? locationIcon1 : locationIcon2} className="max-w-[38px]" alt="" />
                                        </div>



                                        <div className="text-xs">{divRecord?.startsWith('College') ? Number(selectedMarker?.CURRENT_PERCENTAGE == 0 ? selectedMarker?.LAST_PERIOD_PERCENTAGE : selectedMarker?.CURRENT_PERCENTAGE).toFixed(0) : Number(selectedMarker?.CURRENT_PERCENTAGE == 0 ? selectedMarker?.LAST_PERIOD_PERCENTAGE : selectedMarker?.CURRENT_PERCENTAGE).toFixed(1) + "%"}</div>
                                    </div>
                                    <div className="text-xs text-white w-full" style={{ position: "relative", fontSize: "1qpx", top: "3px" }}>
                                        Target :{Number((selectedMarker?.TARGET_PERCENTAGE)).toFixed(1)}%
                                    </div>
                                    <div className="text-xs text-white w-full" style={{ position: "relative", fontSize: "11px", top: "3px" }}>
                                        Last Year :{divRecord?.startsWith('College') ? Number(selectedMarker?.CURRENT_PERCENTAGE == 0 ? selectedMarker?.LAST_PERIOD_PERCENTAGE_PY2 : selectedMarker?.LAST_PERIOD_PERCENTAGE).toFixed(0) : Number(selectedMarker?.CURRENT_PERCENTAGE == 0 ? selectedMarker?.LAST_PERIOD_PERCENTAGE_PY2 : selectedMarker?.LAST_PERIOD_PERCENTAGE).toFixed(1) + "%"}
                                    </div>
                                </div>
                                <ReactEcharts option={StudentCenters} />
                            </div>
                        </div> :
                        <>
                            {/* <p>{divRecord}</p> */}
                            <LoaderContainer loading={School_Performance_Map_ReportLoading} height={"400px"} width={"20%"}>
                                <div style={{ height: "0%" }} className="bg-[#0F0D0B] text-[12px] text-white border-2 border-[#B55D5D] w-full max-w-[28%] lg:max-w-[22%] school_table relative z-10">
                                    <p className="head">{divRecord == 'Economically Disadvantaged' ? 'Free and Reduced Lunch' : divRecord}</p>
                                    {(Boolean(currentItems?.length) && yearShow?.METRIC_GROUP == 'Assessment') && <p className=" flex justify-center items-center">{currentItems && currentItems?.[0]?.CURRENT_PERCENTAGE == 0 ? `(${(yearShow?.METRIC_ID == 10026 || yearShow?.METRIC_ID == 10025) ? 'Winter' : 'Spring'} ${currentItems?.[0]?.SCHOOL_YEAR - 1} from SY:${Number(currentItems?.[0]?.SCHOOL_YEAR) - 2 + "-" + String(currentItems?.[0]?.SCHOOL_YEAR - 1).slice(-2)})` : `(${(yearShow?.METRIC_ID == 10026 || yearShow?.METRIC_ID == 10025) ? 'Winter' : 'Spring'} ${currentItems?.[0]?.SCHOOL_YEAR} from SY:${Number(currentItems?.[0]?.SCHOOL_YEAR) - 1 + "-" + String(currentItems?.[0]?.SCHOOL_YEAR).slice(-2)})`}</p>}
                                    {(Boolean(currentItems?.length) && yearShow?.METRIC_GROUP == 'Graduation') && <p className=" flex justify-center items-center">{currentItems?.[1]?.CURRENT_PERCENTAGE == 0 ? `(Latest SY:${Number(currentItems?.[0]?.SCHOOL_YEAR) - 2 + "-" + String(currentItems?.[0]?.SCHOOL_YEAR - 1)})` : `(Latest SY:${Number(currentItems?.[0]?.SCHOOL_YEAR) - 1 + "-" + String(currentItems?.[0]?.SCHOOL_YEAR)})`}</p>}
                                    <table className="w-full" cellPadding={0} cellSpacing={0}>
                                        <tr className="bg-[#0F0D0B]">
                                            <td align="center" style={{ fontSize: "14px" }}>School Name</td>
                                            <td align="center" style={{ fontSize: "14px" }}>{divRecord == 'Economically Disadvantaged' ? 'Free and Reduced Lunch' : divRecord}</td>
                                        </tr>
                                        {currentItems && currentItems?.map(itr => {
                                            const displayValue = getMetricDisplayValue(itr?.CURRENT_PERCENTAGE, itr?.LAST_PERIOD_PERCENTAGE, divRecord);
                                            let value = format(displayValue, { suffix: itr?.METRIC_TYPE?.toLowerCase() === 'percentage' ? '%' : '', forcedecimals: itr?.METRIC_TYPE?.toLowerCase() === 'percentage' ? 1 : 0 });
                                            return (
                                                <tr>
                                                    <td width='60%'>{itr?.SCHOOL_OFFICIAL_NAME}</td>
                                                    <ValueTooltip heading={itr?.SCHOOL_OFFICIAL_NAME} value1={value} value2={divRecord?.startsWith('College') ? Number(itr?.NUMERIC_VALUE).toFixed(1) + '%' : Number(itr?.NUMERIC_VALUE).toFixed(0)}>
                                                        <td>{value}</td>
                                                    </ValueTooltip>
                                                </tr>
                                            )
                                        })}
                                        <tr>
                                            <td align="center"><button className={`paginationprevious ${currentPage === 1 ? 'disabled' : ''}`} onClick={handlePrevClick} disabled={currentPage === 1}>Previous</button></td>
                                            <td align="center"><button className={`paginationnext ${currentPage === totalPages ? 'disabled' : ''}`} onClick={handleNextClick} disabled={currentPage === totalPages}>Next</button></td>
                                        </tr>
                                    </table>
                                </div>
                            </LoaderContainer>
                        </>

                    }
                </div>
                <div className="absolute left-0 right-0 bottom-14" style={{ width: "91%" }}>
                    <LoaderContainer loading={School_Performance_Metric_ReportLoading} height={"100px"} width={"100%"}>

                        <div className="school_per_sldr" >
                            <Carousel value={School_Performance_Metric_Reportata} numVisible={4} responsiveOptions={responsiveOptions} numScroll={1} itemTemplate={MetricTemplate} /></div>
                    </LoaderContainer>
                </div>

                <div className="flex justify-between items-center fixed left-[100px] right-[150px] bottom-[-5px] text-white p-4 gap-[0.7rem] w-[70%]">
                    <div className="flex gap-[0.7rem]">
                        <div className={`relative flex justify-center items-center bg-black bg-opacity-50 p-2 rounded-md cursor-pointer ${mapType === "roadmap" ? 'border-2 border-white-500' : null}`} onClick={() => handleView('roadmap')}
                            style={{ backgroundImage: `url('/road_map.png')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                            <div className="absolute inset-0 bg-black bg-opacity-50 rounded-md z-10"></div>
                            <span className="relative z-20">Map</span>
                        </div>
                        <div className={`relative flex justify-center items-center bg-black bg-opacity-50 p-2 rounded-md cursor-pointer ${mapType === "satellite" ? 'border-2 border-white-500' : null}`} onClick={() => handleView('satellite')}
                            style={{ backgroundImage: `url('/satellite_image.png')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                            <div className="absolute inset-0 bg-black bg-opacity-50 rounded-md z-10"></div>
                            <span className="relative z-20">Satellite</span>
                        </div>


                    </div>
                    <div class="btn-group flex justify-between btn-group bg-white rounded-md box_sha1 text-[#1d1d31] border-4  text-[13px]  w-full max-w-[245px] 2xl:max-w-[15vw] max-h-[70px] flex items-center text-center justify-center h-[30px]">

                        <div className={`${titles.traffic === "Traffic" ? 'bg-[#79a6d0] rounded-[15px]' : null} w-[30%] h-[30px]`} onClick={() => handleClick('traffic', 'Traffic')} >
                            <button class="btn-group__item btn-group__item" style={{ padding: '0.3rem' }} rounded >Traffic</button>

                        </div>
                        <div className={`${titles.transit === "Transit" ? 'bg-[#79a6d0] rounded-[15px]' : null} w-[30%] h-[30px]`} onClick={() => handleClick('transit', 'Transit')}>

                            <button class="btn-group__item" style={{ padding: '0.3rem' }}>Transit</button>
                        </div>
                        <div className={`${titles.bicycling === "Bicycling" ? 'bg-[#79a6d0] rounded-[15px]' : null} w-[30%] h-[30px]`} onClick={() => handleClick('bicycling', 'Bicycling')}>
                            <button class="btn-group__item" style={{ padding: '0.3rem' }}>Bicycling</button>

                        </div>
                    </div>
                    {/* <div className="flex gap-[0.7rem]">
                        <div className={`relative flex justify-center items-center bg-[#dbe4f7] bg-opacity-50 p-2 rounded-md cursor-pointer ${titles.traffic ? 'border-2 border-white-500' : null}`} onClick={() => handleClick('traffic', 'Traffic')}
                            style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                            <div className="absolute inset-0 bg-black bg-opacity-50 rounded-md z-10"></div>
                            <span className="relative z-20">{titles.traffic || 'Traffic'}</span>
                        </div>
                        <div className={`relative flex justify-center items-center bg-[#dbe4f7] bg-opacity-50 p-2 rounded-md cursor-pointer ${titles.bycycling ? 'border-2 border-white-500' : null}`} onClick={() => handleClick('bicycling', 'Bicycling')}
                            style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                            <div className="absolute inset-0 bg-black bg-opacity-50 rounded-md z-10"></div>
                            <span className="relative z-20">{titles.bicycling || 'Bicycling'}</span>
                        </div>
                        <div className={`relative flex justify-center items-center bg-[#dbe4f7] bg-opacity-50 p-2 rounded-md cursor-pointer ${titles.transit ? 'border-2 border-white-500' : null}`} onClick={() => handleClick('transit', 'Transit')}
                            style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                            <div className="absolute inset-0 bg-black bg-opacity-50 rounded-md z-10"></div>
                            <span className="relative z-20">{titles.transit || 'Transit'}</span>
                        </div>
                    </div> */}
                </div>

            </div>
        </div >
    )
}